import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

// eslint-disable-next-line import/no-default-export
export default Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "StaffLoginAsModalContainer" */
      './StaffLoginAsModalContainer'
    ),
  loading: LoadingModal,
});
